import React, { useEffect, useMemo, useState } from "react"
import { Form, message } from "antd"
import { get } from "@rails/request.js"
import ModalForm from "components/common/form/ModalForm"

interface CompanyFormProps {
  companyId: number
}

function RoleForm(props: CompanyFormProps): JSX.Element {
  const { companyId } = props
  const [form] = Form.useForm()
  const [userOptions, setUserOptions] = useState([])
  const [checkers, setCheckers] = useState([])
  const [approvers, setApprovers] = useState([])
  const [admins, setAdmins] = useState([])

  const fetchCompanyRoleOptions = async () => {
    const response = await get(`/api/v1/admin/companies/${companyId}/role_options`)
    if (response.ok) {
      const parsedData = await response.json
      setUserOptions(parsedData.data.users)
      setCheckers(parsedData.data.checkers)
      setApprovers(parsedData.data.approvers)
      setAdmins(parsedData.data.admins)
    } else {
      message.error(response.error)
    }
  }

  useEffect(() => {
    if (!!companyId) {
      fetchCompanyRoleOptions()
    }
  }, [companyId])

  const fields = [
    {
      type: 'input',
      key: 'company_id',
      hidden: true,
    },
    {
      type: 'select',
      key: 'admins',
      label: '管理员',
      mode: 'multiple',
      options: userOptions
    },
    {
      type: 'select',
      key: 'checkers',
      label: '验收员',
      mode: 'multiple',
      options: userOptions
    },
    {
      type: 'select',
      key: 'approvers',
      label: '审核员',
      mode: 'multiple',
      options: userOptions
    }
  ]

  const data = useMemo(() => {
    return {
      company_id: companyId,
      checkers,
      approvers,
      admins
    }
  }, [companyId, checkers, approvers, admins])

  if (!companyId) return <></>

  return (
    <>
      <ModalForm
        form={form}
        title='修改企业管理员'
        formData={fields}
        data={data}
        submitPath={`/api/v1/admin/companies/${companyId}/roles`}
        submitMethod='POST'
        buttonText='管理员'
        buttonType='default'
      />
    </>
  )
}

export default RoleForm
